import { Box, styled } from '@mui/material'
import i18n from 'i18n'

export const TextButtonContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}))

export const TabMenuContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: '200px',
  borderRadius: '20px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  padding: '8px',
  margin: '8px',
  backgroundColor: theme.palette.card.primary
}))

export const TabMenuItem = styled(Box)<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 16px',
    cursor: 'pointer',
    borderRadius: '12px',
    backgroundColor: selected ? theme.palette.surface.subtle : 'transparent',
    color: selected ? theme.palette.text.primary : theme.palette.text.secondary,
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: selected
        ? theme.palette.surface.subtle
        : theme.palette.surface.hover
    },
    '& svg': {
      width: '20px',
      height: '20px',
      minWidth: '20px',
      minHeight: '20px',
      color: selected
        ? theme.palette.text.primary
        : theme.palette.text.secondary
    }
  })
)

export const TabMenuLabel = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: 'inherit',
  whiteSpace: 'nowrap'
}))

export const DialogLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  minHeight: '500px'
}))

export const TabContentContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: '40px 16px 16px 16px',

  width: '460px',
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: '8px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
    marginRight: '8px'
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.text.disabled,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.card.primary}`,
    backgroundClip: 'padding-box'
  }
}))
